<template>
    <nio-select
        :options="sortedContacts"
        :search-enabled="true"
        :search-external="true"
        :search-loading="searching"
        :value="value"
        ref="select"
        @input="onInput"
        @search="onSearch"
    />
</template>

<script>
    import orderBy from 'lodash/orderBy.js';
    import debounce from 'lodash/debounce.js';
    import { mapState } from 'vuex';
    import Contact from '@/entities/Contact.js';

    export default {
        props: {
            value: {
                type: null,
                required: true,
            },
            phoneRequired: {
                type: Boolean,
                default: false,
            },
            selectedContact: {
                type: Object,
                default: null,
            },
        },

        data: () => ({
            contacts: [],
            searching: false,
        }),

        computed: {
            ...mapState([
                'authUser',
            ]),

            sortedContacts() {
                const contacts = this.contacts.map(contact => ({
                    label: contact.fullName,
                    value: contact.id,
                    subLabel: contact.phones.reduce((accumulator, phone) => {
                        return accumulator || !phone.valid
                            ? accumulator
                            : this.formatPhone(phone.number);
                    }, ''),
                }));

                return orderBy(contacts, 'label');
            },
        },

        methods: {
            onSearch(value) {
                this.searching = true;
                this.debounceSearch(value);
            },

            onInput(value) {
                this.$emit('input', value);
                this.$emit('update:selectedContact', this.contacts.find(c => c.id === value));
            },

            debounceSearch(value) {
                this.search(value);
            },

            async search(value) {
                this.searching = true;

                const response = await this.$axios.get('contacts', {
                    params: {
                        search: value || '',
                        limit: 100,
                        phoneRequired: this.phoneRequired,
                        showNotValidated: true,
                        account_id: this.authUser.account.id,
                    },
                });

                this.searching = false;
                this.contacts = response.data.data.map(contact => {
                    return new Contact(contact);
                });
            },

            open() {
                this.$refs.select.open();
            },
        },

        mounted() {
            this.debounceSearch();
        },

        created() {
            this.debounceSearch = debounce(this.debounceSearch, 750);
        },

        beforeDestroy() {
            this.debounceSearch.cancel();
        },
    };
</script>
